<template>
    <div v-if="isWarning">
        <title-screen title="13"></title-screen>
        <div v-text="warningMessage">
        </div>
    </div>
    <div v-else class="">
        <div class="arms-title">
            いただいた情報を元に登録内容を表示しております。<br>
            表示内容に誤りがあり、変更が必要な場合は、お手数ではございますが、レガシィまでご連絡ください。<br>
        </div>
        <confirm-change-before-route ref="confirm-before-route">
            <el-form-custom class="form mt2 member-arms-edit" ref="member" :model="member" :rules="rules" v-if="formRegister">
                <table class="table-register">
                    <tr>
                        <th id="name" class="column-label required">{{ $t('member.name') }}</th>
                        <td class="column-input">
                            <div class="d-flex">
                            <el-form-item-custom prop="lastName" class="w-45p mr-auto "><input type="text" v-model="member.lastName" placeholder="姓" class="input"></el-form-item-custom>
                            <el-form-item-custom prop="firstName" class="w-45p "><input type="text" v-model="member.firstName" placeholder="名" class="input"></el-form-item-custom>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th id="name-kana" class="column-label required">{{ $t('member.name_kana') }}</th>
                        <td class="column-input">
                            <div class="d-flex">
                            <el-form-item-custom prop="lastNameKana" class="w-45p mr-auto "><input type="text" v-model="member.lastNameKana" placeholder="セイ" class="input"></el-form-item-custom>
                            <el-form-item-custom prop="firstNameKana" class="w-45p "><input type="text" v-model="member.firstNameKana" placeholder="メイ" class="input"></el-form-item-custom>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th id="gender" class="column-label required">{{ $t('member.gender') }}</th>
                        <td class="column-input">
                            <el-form-item-custom prop="gender" class="form-item-radio">
                            <el-radio-group v-model="member.gender">
                                <el-radio :key="1" :label="'1'">{{ $t('commons.male') }}</el-radio>
                                <el-radio :key="2" :label="'2'">{{ $t('commons.female') }}</el-radio>
                            </el-radio-group>
                            </el-form-item-custom>
                        </td>
                    </tr>
                    <tr>
                    <th id="phone" class="column-label">{{ $t('member.phone') }}</th>
                    <td class="column-input max-width-220 tel">
                        <el-form-item-custom prop="phone">
                        <input type="text" class="input mr-3" v-model="member.phone" placeholder="03-xxxx-xxxx">
                        <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
                        </el-form-item-custom>
                    </td>
                    </tr>
                    <tr>
                        <th id="mobile-phone" class="column-label">{{ $t('member.mobile_phone') }}</th>
                        <td class="column-input max-width-220 tel">
                            <el-form-item-custom prop="mobilePhone">
                            <input type="text" class=" mr-3" :disabled="disableEmail === false" v-model="member.mobilePhone" placeholder="070-xxxx-xxxx">
                            <span class="d-inline-block">半角で、ハイフンを含めて登録してください</span>
                            <div class="el-form-item__error" v-if="msgDupMobilePhone.length !== 0">
                                {{msgDupMobilePhone}}
                            </div>
                            </el-form-item-custom>
                        </td>
                    </tr>
                    <tr>
                        <th id="email" class="column-label">{{ $t('member.email') }}</th>
                        <td class="column-input max-width-300">
                            <el-form-item-custom prop="email" :class="msgDupEmail.length !== 0 ? 'pb-3' : ''">
                            <input type="email" class="input" :disabled="disableEmail === true" v-model="member.email" placeholder="xxxxxxx@legacy.ne.jp">
                            <div class="el-form-item__error" v-if="msgDupEmail.length !== 0">
                                {{msgDupEmail}}
                            </div>
                            </el-form-item-custom>
                        </td>
                        </tr>
                    <tr>
                    <tr class="login-id-row">
                        <th id="login-id" class="column-label login-id required">
                            {{ $t('member.login_id') }}
                        </th>
                        <td class="column-input max-width-400">
                            <el-form-item-custom prop="loginId" class="">
                            <input type="text" class="input" v-model="member.loginId" disabled>
                            <span class="d-inline-block small-text">上記のメールアドレスまたは電話番号が、今後のログインIDとして自動的に設定されます</span>
                            <el-checkbox class="cb" v-model="cbSaveLoginId">IDを保存する</el-checkbox>
                            <div class="el-form-item__error" v-if="msgDupLoginId.length !== 0">
                                {{msgDupLoginId}}
                            </div>
                            </el-form-item-custom>
                        </td>
                    </tr>
                    <tr class="password-row">
                        <th id="password" class="column-label password required">
                            {{ $t('member.password') }}
                            <br>
                            <span class="d-inline-block small-text">半角英数字記号すべて使用して、8～32文字</span>
                            <br>
                            <span class="d-inline-block small-text tooltip-text" v-tooltip.top-start="{ content: '利用可能記号: &#33;&#34;&#35;&#36;&#37;&#38;\'&#40;&#41;&#42;&#43;&#44;&#45;&#46;&#47;&#58;&#59;&#60;&#61;&#62;&#63;&#64;&#91;&#92;&#93;&#94;&#95;&#96;&#123;&#124;&#125;&#126;', classes: ['small-text'], trigger: 'hover click' }">※利用可能記号確認</span>
                        </th>
                        <td class="column-input max-width-400">
                            <el-form-item-custom prop="password" class="">
                            <input type="password" class="input" v-model="member.password">
                            <span class="d-inline-block small-text">小文字と数字を含めて8～32文字で組み合わせて設定してください</span>
                            </el-form-item-custom>
                        </td>
                    </tr>
                    <tr>
                        <th id="password-confirm" class="column-label required">{{ $t('member.password_confirm') }}</th>
                        <td class="column-input max-width-400 password-confirm">
                            <el-form-item-custom prop="passwordConfirm"><input type="password" class="input" v-model="member.passwordConfirm"></el-form-item-custom>
                        </td>
                    </tr>
                    <tr>
                        <th id="birthday-title" class="column-label required">{{ $t('member.birthday') }}</th>
                        <td id="birthday" class="column-input xxs-input-birthday">
                            <el-form-item-custom prop="birthday">
                            <date-select @change="$refs['confirm-before-route'].change()" v-model="member.birthday" :defaultYear="defaultBirthdayYear"></date-select>
                            </el-form-item-custom>
                        </td>
                    </tr>
                    <tr>
                        <th id="zip-code" class="column-label">{{ $t('member.zip_code') }}</th>
                        <td class="column-input max-width-220">
                            <el-form-item-custom prop="zipCode">
                            <zip-code-input class="d-inline-block mr-3" v-model="member.zipCode"></zip-code-input>
                            </el-form-item-custom>
                        </td>
                    </tr>
                    <tr>
                        <th id="prefecture" class="column-label required">{{ $t('member.prefecture') }}</th>
                        <td class="column-input max-width-220">
                            <el-form-item-custom prop="prefecture">
                                <prefecture-select
                                    :changeAction="prefectureChange"
                                    v-model="member.prefecture"
                                    :prefectureMaster="prefectureMaster"
                                ></prefecture-select>
                            </el-form-item-custom>
                        </td>
                    </tr>
                    <tr>
                        <th id="address" class="column-label">{{ $t('member.address') }}</th>
                        <td class="column-input max-width-400">
                            <el-form-item-custom prop="address"><input type="text" v-model="member.address"></el-form-item-custom>
                        </td>
                    </tr>
                    <tr>
                        <th id="use-mail-magazine" class="column-label required">{{ $t('member.use_mail_magazine') }}</th>
                        <td class="column-input max-width-220">
                            <el-radio-group v-model="member.useMailMagazine">
                            <el-radio :key="true" :label="true">{{ $t('commons.yes') }}</el-radio>
                            <el-radio :key="false" :label="false">{{ $t('commons.no') }}</el-radio>
                            </el-radio-group>
                        </td>
                    </tr>
                </table>
                <div class="button">
                    <div class="checkbox-area">
                        <el-checkbox v-model="isAgreeMemberAgreement" :class="checkPolicyClass" @change="handlePolicy">
                            <a href="https://legacy.ne.jp/privacy-customer/" target="_blank" rel="noopener noreferrer">
                                <span class="active-link">{{ $t('words.member.agree_member_agreement') }}</span>
                            </a>
                        </el-checkbox>
                            <br>
                        <div class="warning-policy" v-if="checkPolicy">
                            「『個人情報の取扱いについて』同意します」にチェックしてください。
                        </div>
                        <el-checkbox v-model="isAgreeTermsOfService" :class="checkTermClass" @change="handleTerm">
                            <router-link to="/termsOfService" target="_blank">
                                <span class="active-link">{{ $t('words.member.agree_terms_of_service') }}</span>
                            </router-link>
                        </el-checkbox>
                        <div class="warning-term" v-if="checkTerm">
                            「利用規約に同意します」にチェックしてください。
                        </div>
                    </div>
                    <div class="mt2 text-center">
                        <el-button @click="resetForm('member')">{{ $t('commons.clear') }}</el-button>
                        <el-button @click="submitForm('member')">{{ $t('commons.register') }}</el-button>
                    </div>
                </div>
            </el-form-custom>
        </confirm-change-before-route>
        <el-form class="form mt2" v-show="!formRegister">
            <table class="table-register">
                <tr>
                    <th id="cf-name" class="column-label"><p>{{ $t('member.name') }}</p></th>
                    <td class="column-input">
                        <p class="d-inline-block mr-3">{{member.lastName}}</p>
                        <p class="d-inline-block">{{member.firstName}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-name-kana" class="column-label">{{ $t('member.name_kana') }}</th>
                    <td class="column-input">
                        <p class="d-inline-block mr-3">{{member.lastNameKana}}</p>
                        <p class="d-inline-block">{{member.firstNameKana}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-gander" class="column-label">{{ $t('member.gender') }}</th>
                    <td class="column-input">
                        <el-form-item prop="gender">
                            <p>{{member.gender === '1' ? '男性' : '女性'}}</p>
                        </el-form-item>
                    </td>
                </tr>
                <tr>
                    <th id="cf-phone" class="column-label">{{ $t('member.phone') }}</th>
                    <td class="column-input max-width-400">
                        <p>{{member.phone}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-mobile-phone" class="column-label">{{ $t('member.mobile_phone') }}</th>
                    <td class="column-input max-width-400">
                        <p>{{member.mobilePhone}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-email" class="column-label">{{ $t('member.email') }}</th>
                    <td class="column-input max-width-400">
                        <p>{{member.email}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-login-id" class="column-label">{{ $t('member.login_id') }}</th>
                    <td class="column-input max-width-400">
                        <p>{{member.loginId}}</p>
                        <el-checkbox class="cb" v-model="cbSaveLoginId" disabled>IDを保存する</el-checkbox>
                    </td>
                </tr>
                <tr>
                    <th id="cf-password" class="column-label">{{ $t('member.password') }}</th>
                    <td class="column-input max-width-400">
                        <p>********</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-password-confirm" class="column-label">{{ $t('member.password_confirm') }}</th>
                    <td class="column-input max-width-400">
                        <p>********</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-birthday" class="column-label">{{ $t('member.birthday') }}</th>
                    <td>
                        <p>{{member.birthday | formatDate}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-zip-code" class="column-label">{{ $t('member.zip_code') }}</th>
                    <td class="column-input max-width-220">
                        <p>{{member.zipCode}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-prefecture" class="column-label">{{ $t('member.prefecture') }}</th>
                    <td class="column-input max-width-220">
                        <p>{{member.prefecture}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-address" class="column-label">{{ $t('member.address') }}</th>
                    <td class="column-input max-width-220">
                        <p>{{member.address}}</p>
                    </td>
                </tr>
                <tr>
                    <th id="cf-use-mail-magazine" class="column-label">{{ $t('member.use_mail_magazine') }}</th>
                    <td class="column-input max-width-220">
                        <p>{{member.useMailMagazine ? 'はい' : 'いいえ'}}</p>
                    </td>
                </tr>
            </table>
            <div class="button">
                <div class="mt2 text-center">
                    <el-button @click="formRegister = true">{{ $t('commons.back') }}</el-button>
                    <el-button @click="registerForm" :disabled="!isRegistrable">{{ $t('commons.register') }}</el-button>
                </div>
            </div>
        </el-form>
        <confirm-dialog
            ref="confirm-reset-form"
        ></confirm-dialog>
        <div>
        </div>
    </div>
</template>

<script>
    import memberApi from '@/api/member/member-client.js'
    import ConfirmDialog from '@/components/dialog/ConfirmDialog'
    import moment from 'moment'
    import TitleScreen from '../../../../components/common/TitleScreen'
    import ContactApi from '@/api/contact/contact-cl'
    import DateSelect from '../../../../components/common/DateSelect'
    import ZipCodeInput from '../../../../components/common/ZipCodeInput'
    import ConfirmChangeBeforeRoute from '../../../../components/common/ConfirmChangeBeforeRoute'
    import messageFormErrUtil from './messageFormErrUtil'
    import PrefectureSelect from '@/components/common/PrefectureSelect'
    import saveLoginIdMixin from '../../../../mixins/saveLoginIdMixin'
    import { applySessionFromResponse } from '@/common/authSession'
    import { routeNameForSessionFlag } from '@/common/sessionFlagRouting'
    import JwtService from '@/common/jwt.service'

    export default {
        name: 'MemberArmsEdit',
        mixins: [messageFormErrUtil, saveLoginIdMixin],
        components: {
            ConfirmChangeBeforeRoute,
            ZipCodeInput,
            DateSelect,
            TitleScreen,
            ConfirmDialog,
            PrefectureSelect
        },
        data () {
            const passwordConfirm = (rule, value, callback) => {
                if (value !== this.member.password) {
                    callback(new Error('パスワード（確認）とパスワードが一致しません。'))
                } else {
                    callback()
                }
            }
            const validateDate = (rule, value, callback) => {
            if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
                callback(new Error('正しい日付を選択してください'))
            } else {
                callback()
            }
            }
            return {
                token: null,
                member: {
                    id: '',
                    loginId: '',
                    lastName: '',
                    password: '',
                    passwordConfirm: '',
                    firstName: '',
                    lastNameKana: '',
                    firstNameKana: '',
                    email: '',
                    phone: '',
                    mobilePhone: '',
                    zipCode: '',
                    prefecture: '',
                    address: '',
                    gender: '',
                    birthday: '',
                    useMailMagazine: true
                },
                rules: {
                    // login_id is server-derived from whichever of email/mobilePhone this ARMS
                    // invitation's registerType locks; the field is auto-filled and disabled
                    // below, so no shape/length rule is applied here.
                    loginId: [
                        { required: true, message: '本人確認リンクの読み込みに失敗しました。お手数ですが、担当者までご連絡ください。', trigger: 'blur' }
                    ],
                    lastName: [
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.last_name') }), trigger: 'change' },
                        { max: 50, message: '50文字以内で入力してください' }
                    ],
                    firstName: [
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.first_name') }), trigger: 'change' },
                        { max: 50, message: '50文字以内で入力してください' }
                    ],
                    lastNameKana: [
                        { pattern: /^[ァ-ンヴー]+$/, message: '全角カタカナで入力してください' },
                        { max: 50, message: '50文字以内で入力してください' },
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.last_name_kana') }), trigger: 'change' }
                    ],
                    firstNameKana: [
                        { pattern: /^[ァ-ンヴー]+$/, message: '全角カタカナで入力してください' },
                        { max: 50, message: '50文字以内で入力してください' },
                        { required: true, message: this.$t('rules.required', { key: this.$t('member.first_name_kana') }), trigger: 'change' }
                    ],
                    gender: [
                        { required: true, message: this.$t('rules.no_select', { key: this.$t('member.gender') }), trigger: 'blur' }
                    ],
                    email: [
                        { required: false, pattern: /^[a-zA-Z0-9]{1}[a-zA-Z0-9_.-]*@{1}(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|([a-zA-Z0-9_.-]{1,}\.[a-zA-Z0-9]{2,}))$/, message: this.$t('rules.email'), trigger: 'blur' }
                    ],
                    phone: [
                        { required: false, pattern: /^(?:\d{2}-\d{4}|\d{3}-\d{3}|\d{4}-\d{2}|\d{5}-\d)-\d{4}$/, message: this.$t('rules.number', { key: this.$t('member.phone') }), trigger: 'blur' }
                    ],
                    mobilePhone: [
                        { required: false, pattern: /^\d{3}-\d{4}-\d{4}$/, message: this.$t('rules.number', { key: this.$t('member.mobile_phone') }), trigger: 'blur' }
                    ],
                    zipCode: [
                        { required: false, pattern: /^[0-9]{3}-[0-9]{4}$/, message: this.$t('rules.zip_code'), trigger: 'blur' }
                    ],
                    birthday: [
                        { validator: validateDate, trigger: 'blur' }
                    ],
                    password: [
                        { required: true,
                            // PasswordPolicy.kt: 8+ chars, lowercase+digit required, "¥" forbidden.
                            pattern: /^(?=.*[a-z])(?=.*\d)[^¥]{8,32}$/,
                            message: '小文字と数字を含めて8文字以上で入力してください',
                            trigger: 'change'
                        }
                    ],
                    passwordConfirm: [
                        { validator: passwordConfirm, trigger: 'change' }
                    ],
                    prefecture: [
                        { required: true, message: this.$t('rules.no_select', { key: this.$t('member.prefecture') }), trigger: 'change' }
                    ],
                    address: [
                        { required: false, max: 200, message: '200文字以内で入力してください', trigger: 'blur' }
                    ]
                },
                isAgreeMemberAgreement: false,
                isAgreeTermsOfService: false,
                formRegister: true,
                formDisabled: false,
                isWarning: false,
                isError: false,
                needCheck: false,
                prefectureMaster: [],
                registerType: null,
                registerValue: null,
                warningMessage: '',
                expiredMessage: 'このURLは有効期限が切れているか、無効です。',
                registeredMessage: '更新しました。',
                msgDupLoginId: '',
                msgDupEmail: '',
                msgDupMobilePhone: '',
                checkPolicy: false,
                checkTerm: false,
                disableEmail: true
            }
        },
        computed: {
            isRegistrable: function () {
                return this.isAgreeTermsOfService && this.isAgreeMemberAgreement
            },
            defaultBirthdayYear: function () {
                return '1960'
            },
            checkPolicyClass: function () {
                return this.checkPolicy ? 'is-error' : ''
            },
            checkTermClass: function () {
                return this.checkTerm ? 'is-error' : ''
            }
        },
        created () {
            this.token = this.$route.query.token
            if (!this.token) {
                this.isWarning = true
                this.warningMessage = this.expiredMessage
                return
            }
            this.loadMemberInfo(this.token)
            this.loadPrefecture()
            // this.$refs['member'].clearValidate()
        },
        beforeUpdate () {
            if (this.needCheck) {
                this.$refs['member'].validate((valid) => {
                    if (valid) {
                        this.isError = false
                    } else {
                        this.msgDupLoginId = ''
                        this.msgDupEmail = ''
                        this.msgDupMobilePhone = ''
                        this.isError = true
                    }
                })
            }
        },
        methods: {
            async loadMemberInfo (token) {
                try {
                    const res = await memberApi.getMemberInfoFromUrlToken(token)
                    this.member = res.member
                    // ARMS連携の場合の性別は、項目が存在しないために'0'が渡ってくるので明示的に空を設定する。
                    this.member.gender = ''
                    this.member.useMailMagazine = true
                    this.disableEmail = res.isValidByEmail
                    // login_idは常にこのARMS招待のregisterTypeが固定する識別子(email優先、
                    // 無ければmobilePhone)と一致させる - ユーザーが自由に入力できる別個のIDではない。
                    this.member.loginId = this.disableEmail ? this.member.email : this.member.mobilePhone

                    // リンクが期限切れでなければ、フォーム描画と並行してランディング時点の
                    // 重複チェックを行う。重複が見つかった場合はフォームを表示する前に
                    // ログイン画面へ誘導する。
                    if (!this.isWarning) {
                        await this.checkLandingCollision(token, this.member.loginId)
                    }
                } catch (e) {
                    this.isWarning = true
                    this.warningMessage = this.expiredMessage
                }
            },
            async checkLandingCollision (token, loginId) {
                try {
                    const res = await memberApi.checkArmsEditCollision(token)
                    if (res && res.hasCollision) {
                        // query param経由でrouteMember.jsのガードにログインダイアログを開かせる -
                        // ここで直接dispatchすると、遷移先(/portal)自身のCHECK_AUTH_CLIENTが
                        // isOpenLoginDialogを即座にfalseへ戻してしまう。
                        this.$router.push({ name: 'portal', query: { accountExists: '1', loginId: loginId } })
                    }
                } catch (e) {
                    // フェイルオープン: Cognito到達不能やtoken不正の場合でもここではブロックしない -
                    // 入力画面の重複チェック、および確認画面の最終送信側がフェイルクローズの安全網となる。
                }
            },
            async loadPrefecture () {
                const res = await ContactApi.getInformPrefectureMaster()
                this.prefectureMaster = res.data.data
            },
            prefectureChange () {
                this.$refs['confirm-before-route'].change()
            },
            submitForm (formName) {
                this.needCheck = true
                this.msgDupLoginId = ''
                this.msgDupEmail = ''
                this.msgDupMobilePhone = ''
                this.checkTerm = !this.isAgreeTermsOfService
                this.checkPolicy = !this.isAgreeMemberAgreement
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!this.isRegistrable) {
                            this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
                            return false
                        }
                        this.isDuplicate().then(() => {
                            this.formRegister = false
                        }).catch(() => this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー'))
                    } else {
                        this.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
                    }
                })
            },
            resetForm (formName) {
                this.$refs['confirm-reset-form'].open({
                    message: '入力内容がクリアされますがよろしいですか？'
                }).then((confirm) => {
                    if (confirm) {
                        this.isAgreeTermsOfService = false
                        this.isAgreeMemberAgreement = false
                        this.member.firstNameKana = ''
                        this.member.lastNameKana = ''
                        this.member.gender = null
                        this.member.prefecture = null
                        this.member.loginId = ''
                        this.member.password = ''
                        this.member.passwordConfirm = ''
                        this.$nextTick(() => {
                            this.$refs[formName].clearValidate()
                        })
                    }
                })
            },
            registerForm () {
                // let requestData = {
                //     loginId: this.member.loginId,
                //     password: this.member.password,
                //     lastNameKana: this.member.lastNameKana,
                //     firstNameKana: this.member.firstNameKana,
                //     prefecture: this.member.prefecture,
                //     gender: this.member.gender,
                //     useMailMagazine: this.member.useMailMagazine
                // }
                let requestData = this.member
                // POST /member/arms-edit issues its own session directly; applySessionFromResponse
                // is async and must be awaited before navigating, since the resulting session flag
                // decides where to route next (identity verification, terms, or the portal).
                memberApi.editMemberArms(this.token, requestData).then(response => {
                    this.doSaveLoginId(this.member.loginId)
                    this.$refs['confirm-before-route'].reset()
                    return applySessionFromResponse(this.$store, response).then(() => {
                        this.$alert('ご登録ありがとうございました。続いて本人確認を行ってください。', '', {
                            confirmButtonText: '本人確認へ進む',
                            center: true,
                            confirmButtonClass: 'btn-msg-box'
                        }).then(() => {
                            this.$router.push({ name: routeNameForSessionFlag(JwtService.getSessionFlag()) || 'portalMember' })
                        }).catch(() => {})
                    })
                }).catch(error => {
                    this.alertMessage(error.response.data.message, 'エラー')
                })
            },
            isDuplicate () {
                return new Promise((resolve, reject) => {
                    let data = {
                        'memberId': this.member.id,
                        'loginId': this.member.loginId,
                        'email': this.member.email,
                        'mobilePhone': this.member.mobilePhone
                    }
                    memberApi.validateDuplicate(data).then(res => {
                        if (res.data !== null && Object.keys(res.data).length !== 0) {
                            this.msgDupLoginId = res.data.loginId ? res.data.loginId : ''
                            this.msgDupEmail = res.data.email ? res.data.email : ''
                            this.msgDupMobilePhone = res.data.mobilePhone ? res.data.mobilePhone : ''
                        }
                        if (this.msgDupLoginId.length !== 0 || this.msgDupMobilePhone.length !== 0 || this.msgDupEmail.length !== 0) {
                            // eslint-disable-next-line prefer-promise-reject-errors
                            reject()
                            return
                        }
                        this.checkCognitoCollision().then(resolve).catch(reject)
                    }).catch(err => {
                        this.showMsgError(this, 'member', err.response.data.message)
                    })
                })
            },
            // ローカルDBの重複チェックに続けて、この招待の固定識別子(ロック済みフィールド)に
            // ついてCognito側の重複も確認する。ランディング時のチェックと同じfail-open
            // エンドポイントを再利用し、実際に重複が見つかった場合のみ確認画面への遷移を
            // ブロックする。Cognito障害時はブロックしない(フェイルオープン) - 確認画面側の
            // 最終送信チェック(fail-closed)が最後の安全網となる。
            checkCognitoCollision () {
                return new Promise((resolve, reject) => {
                    memberApi.checkArmsEditCollision(this.token).then(res => {
                        if (res && res.hasCollision) {
                            const message = 'こちらの情報は既に会員登録されています。'
                            if (this.disableEmail) {
                                this.msgDupEmail = message
                            } else {
                                this.msgDupMobilePhone = message
                            }
                            // eslint-disable-next-line prefer-promise-reject-errors
                            reject()
                            return
                        }
                        resolve()
                    }).catch(() => {
                        // フェイルオープン: Cognito到達不能やtoken不正の場合でもここではブロックしない。
                        resolve()
                    })
                })
            },
            alertMessage (message, title) {
                this.$alert(message, title, {
                    confirmButtonText: this.$t('commons.ok')
                })
            },
            handlePolicy () {
                this.checkPolicy = !this.isAgreeMemberAgreement
            },
            handleTerm () {
                this.checkTerm = !this.isAgreeTermsOfService
            }
        },
        filters: {
          formatDate: function (val) {
              if (val) {
                  return moment(val).format('YYYY年MM月DD日')
              }
          }
        },
        beforeRouteLeave (to, from, next) {
            if (this.isWarning) {
                next()
            } else {
                this.$refs['confirm-before-route'].openConfirm().then((confirm) => {
                    if (confirm) {
                        next()
                    } else {
                        next(false)
                    }
                })
            }
        }
    }
</script>

<style>
  @import 'member_register.css';
  @import "../../../../assets/css/client_custom.css";
  @import "../../../../assets/css/custom.css";
</style>
